// @ts-strict-ignore
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Input2FA, QRCode } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'

interface Enable2FAVerifyModalProps {
  secret: string
  isLoading: boolean
  hasError: boolean
  onChange: (val: string) => void
}

const Enable2FAVerifyModal = ({
  secret,
  isLoading,
  hasError,
  onChange,
}: Enable2FAVerifyModalProps) => {
  const { t } = useTranslation()

  const [qrCodeUrl, setQrCodeUrl] = useState('')

  const { profile } = useProfileContext()

  useEffect(() => {
    const otpUrl = `otpauth://totp/BVNK:${profile?.firstName}?secret=${secret}&issuer=BVNK&algorithm=SHA1&digits=6&period=30`
    if (secret.length > 0) {
      setQrCodeUrl(otpUrl)
    }
  }, [secret, profile])

  return (
    <Box flexCol gapY={24}>
      <span className="text-body-regular text-foreground-subdued text-center">
        {t('qrCodeScanNotice')}
      </span>

      <Box className="mx-auto">
        <QRCode value={qrCodeUrl} />
      </Box>

      <Box flex flexCol align="center" gapY={24} width="full">
        <Box width="full">
          <Input2FA
            label={t('authCodeConfirm')}
            testId="otc-2FA-input"
            loading={isLoading}
            onComplete={value => onChange(value)}
            error={hasError && t('incorrectOtpCode')}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Enable2FAVerifyModal
